import { render } from "./market-switcher-data.vue?vue&type=template&id=135ed2c8"
import script from "./market-switcher-data.vue?vue&type=script&lang=js"
export * from "./market-switcher-data.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bornasepic/Desktop/projects/grau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__